import React from 'react';
import { ArrowRight } from 'lucide-react';
import { StatusBadge } from './StatusBadge';
import type { Initiative } from '../../data/initiatives';
type InitiativeCardProps = {
  initiative: Initiative;
};
export function InitiativeCard({
  initiative
}: InitiativeCardProps) {
  return <article aria-labelledby={`initiative-${initiative.slug}`} className="bg-white border border-line rounded-lg p-8 lg:p-10 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16" data-id="element-691" data-mp="2z732aujn3gnz">
      <div className="lg:col-span-5" data-id="element-692" data-mp="2q64xwb5ah74v">
        <p className="text-sm font-medium text-teal mb-2" data-id="element-693" data-mp="2q53ixvl5k0hv">{initiative.category}</p>
        <h3 id={`initiative-${initiative.slug}`} className="font-heading font-bold text-3xl text-ink-dark tracking-tight" data-id="element-694" data-mp="2l68sc7gy17n7">
          {initiative.name}
        </h3>
        <StatusBadge className="mt-4" data-id="element-695" data-mp="jg72iedvftxk">{initiative.status}</StatusBadge>
      </div>
      <div className="lg:col-span-7 flex flex-col" data-id="element-696" data-mp="egko41mb47n6">
        <p className="text-lg text-ink-dark leading-relaxed mb-8" data-id="element-697" data-mp="eh3ymx9mntr6">{initiative.description}</p>
        <a href={initiative.href} className="mt-auto self-start inline-flex items-center gap-2 bg-navy hover:bg-navy-light text-white font-semibold px-5 py-3 rounded-md transition-colors duration-150 whitespace-nowrap focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal" data-id="element-698" data-mp="3vqv03652s6kq">
          {initiative.cta}
          <ArrowRight size={16} aria-hidden="true" data-id="element-699" data-mp="ichwgnkezd9q" />
        </a>
      </div>
    </article>;
}